import { render } from "./IssueConsolidated.vue?vue&type=template&id=10a79d7e"
import script from "./IssueConsolidated.vue?vue&type=script&lang=js"
export * from "./IssueConsolidated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__